import { ProjectListIndicators } from './ProjectListIndicators';

export const BoxTotalsProfit = () => <ProjectListIndicators mode="profit" />;
